<script lang="ts">
    import { onMount } from 'svelte';
    import { animate, inView } from '@motionone/dom';
    // Import a few Carbon icons as examples
    import GlobeIcon from 'carbon-icons-svelte/lib/Globe.svelte';
    import AiIcon from 'carbon-icons-svelte/lib/Ai.svelte';
    import DashboardIcon from 'carbon-icons-svelte/lib/Dashboard.svelte';
    import CloudMonitoringIcon from 'carbon-icons-svelte/lib/CloudMonitoring.svelte';
    import UserMultipleIcon from 'carbon-icons-svelte/lib/UserMultiple.svelte';
    import MapBoundaryVegetationIcon from 'carbon-icons-svelte/lib/MapBoundaryVegetation.svelte';
    import HospitalIcon from 'carbon-icons-svelte/lib/Hospital.svelte';
    // Add more imports as needed

    export let icon: string;
    export let title: string;
    export let description: string;
    export let delay: number = 0;

    let cell: HTMLElement;

    // Lookup table for icon names
    const iconMap: { [key: string]: any } = {
        globe: GlobeIcon,
        cpu: AiIcon,
        layout: DashboardIcon,
        CloudMonitoring: CloudMonitoringIcon,
        user: UserMultipleIcon,
        map: MapBoundaryVegetationIcon,
        hospital: HospitalIcon,
        // Add more mappings as needed
    };

    // Fallback icon if not found
    let IconComponent;
    $: IconComponent = iconMap[icon] || null;

    onMount(() => {
        inView(cell, ({ target }) => {
            // Add will-change to optimize performance
            (target as HTMLElement).style.willChange = 'transform, opacity, background-color, color';
            
            animate(
                target,
                { 
                    opacity: [0, 1],
                    transform: [
                        'translate3d(0, 40px, 0)',
                        'translate3d(0, 0, 0)'
                    ],
                    filter: ['blur(4px)', 'blur(0px)']
                },
                { 
                    duration: 0.6,
                    easing: [0.22, 1, 0.36, 1],
                    delay: delay * 0.1
                }
            ).finished.then(() => {
                // After fade in, animate the color inversion
                animate(
                    target,
                    {
                        backgroundColor: ['white', 'black'],
                        color: ['black', 'white']
                    },
                    {
                        duration: 0.4,
                        easing: [0.22, 1, 0.36, 1]
                    }
                );
                // Clean up will-change
                (target as HTMLElement).style.willChange = 'auto';
            });
        }, { 
            amount: 0.2,
            margin: "50px 0px"
        });
    });
</script>

<style>
    .feature-cell {
        background-color: white;
        color: black;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
        padding: 2rem;
        border-radius: 0;
    }

    .feature-cell svg {
        color: currentColor;
    }

    .cell {
        color: #bcbdbd;
        font-size: 0.9rem !important;
        line-height: 1.4;
        max-width: 38ch;
        margin: 0 auto;
        text-align: left;
    }

    .title {
        font-size: 1rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
    }

    @media (min-width: 640px) {
      .feature-cell p {
        font-size: 0.95rem;
        max-width: 32ch;
      }
    }

    @media (min-width: 1024px) {
      .feature-cell p {
        font-size: 1.05rem;
        max-width: 28ch;
      }
    }
</style>

<div 
    class="feature-cell !rounded-none" 
    bind:this={cell}
>
    <h3 class="title">{title}</h3>
    <p class="cell">{description}</p>
</div> 